export default __webpack_public_path__ + "static/media/profileWithoutBadge.c678d4fc.svg";